import { createFileRoute } from "@tanstack/react-router";
import { useSuspenseQuery } from "@tanstack/react-query";
import { suspenseOptions } from "@/lib/suspense-query";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { getGetCatalogProductQueryOptions } from "@/requests/gen/react-query/catalog-product";
import { CatalogCrumbs } from "../../-crumbs";
import ContentsForm from "./-form";
import numericId from "@/lib/numeric-id";

export const Route = createFileRoute(
  "/_private/catalog-product/$catalogProductId/components/",
)({
  loader: ({ context: { queryClient }, params: { catalogProductId } }) =>
    queryClient.ensureQueryData(
      getGetCatalogProductQueryOptions(numericId(catalogProductId)),
    ),
  component: CatalogProductComponentsPage,
});

function CatalogProductComponentsPage() {
  const { catalogProductId } = Route.useParams();
  const catalogProductIdInt = numericId(catalogProductId);

  const { data: catalogProduct, isLoading } = useSuspenseQuery(
    suspenseOptions(getGetCatalogProductQueryOptions(catalogProductIdInt)),
  );

  return (
    <div>
      <title>{`${catalogProduct?.product_base.name} Components - Legrande Health Portal`}</title>
      <CatalogCrumbs />
      <Card>
        <CardHeader>
          <CardTitle>{isLoading ? "Loading..." : "Components"}</CardTitle>
          <CardDescription>
            Add or modify the components that make up this product.
          </CardDescription>
        </CardHeader>
        <CardContent>
          {!isLoading && catalogProduct && (
            <ContentsForm catalogProduct={catalogProduct} />
          )}
        </CardContent>
      </Card>
    </div>
  );
}
